import { render } from "./SelectionDatagridVehicleTypeRow.vue?vue&type=template&id=317433b8"
import script from "./SelectionDatagridVehicleTypeRow.vue?vue&type=script&lang=js"
export * from "./SelectionDatagridVehicleTypeRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__